<template>
  <section class="appointmentForm">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="ruleForm" v-if="state === 'form'">
      <el-col :span="12">
        <el-form-item label="预约社区" class="fonts" prop="index">
          <el-select v-model="ruleForm.index" placeholder="请选择预约社区" class="w240"  @change="changeSq">
            <el-option v-for="(item, index) in dataList" :key="index" :label="item.project_full_name" :value="index"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="预约房型" class="fonts" prop="room_type_id">
          <el-select v-model="ruleForm.room_type_id" placeholder="请选择预约房型" class="w240">
            <el-option v-for="(item, index) in activeshequ" :key="index" :label="item.room_type_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
			<el-col :span="24">
				<el-form-item label="预计入住日期" class="fonts" prop="check_in_time">
          <el-date-picker
            class="w640"
            v-model="ruleForm.check_in_time"
            value-format="timestamp"
            type="date"
            placeholder="选择日期"
            align="right"
            :picker-options="pickerOptions">
          </el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item label="姓名" class="fonts" prop="check_in_name">
					<el-input v-model="ruleForm.check_in_name" class="w640" placeholder="请输入姓名"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item label="手机号码" class="fonts" prop="check_in_phone">
					<el-input v-model="ruleForm.check_in_phone" class="w640" placeholder="请输入手机号码"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="24">
				<el-form-item label="微信号" class="fonts">
					<el-input v-model="ruleForm.check_in_weixin" class="w640" placeholder="请输入微信号"></el-input>
				</el-form-item>
			</el-col>
    </el-form>
		<el-col class="success" :span="24" v-if="state === 'success'">
			<div class="img">
        <img src="../assets/img/cg.png" alt="">
      </div>
			<div class="tis">
				<p class="title">提交成功</p>
				<p class="text">24小时内，将有公寓管家联系您安排看房，请耐心等待，</p>
				<p class="text">期间请保持手机畅通或及时关注微信信息，感谢您关注乐璟服务公寓</p>
			</div>
		</el-col>
  </section>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import {submitAppointment} from '../services/api'
  export default {
    data () {
      let phoneValid = (rule, value, callback) => {
        let reg = ''
        reg = /^[1][1-9][0-9]{9}$/
        if (!reg.test(value)) {
          return callback(new Error('手机号码不正确'))
        }
        callback()
      }
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        activeshequ: [],
        rules:{
          index: [
            { required: true, message: '请选择预约社区', trigger: 'change' }
          ],
          room_type_id: [
            { required: true, message: '请选择预约房型', trigger: 'change' }
          ],
          check_in_time: [
            { required: true, message: '请选择入住日期', trigger: 'change' }
          ],
          check_in_name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          check_in_phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: phoneValid, trigger: 'blur' }
          ],
        },
        ruleForm: {},
				state: 'form'
      }
    },
    props: {
    },
    computed: {
      ...mapState({
        dataList: state => state.appointmentItem,
        activeCity: state => state.activeCity
      })
    },
		methods: {
      ...mapActions([
        'getAppointmentItem'
      ]),
      changeSq() {
        if(this.activeCity.room_type_id) {
          this.$set(this.ruleForm, 'room_type_id', this.activeCity.room_type_id)
        } else {
          this.$set(this.ruleForm, 'room_type_id', '')
        }
        if (this.ruleForm.index === '' || this.ruleForm.index === undefined) {
          return this.activeshequ = []
        }
        this.activeshequ = this.dataList[this.ruleForm.index].room_types
      },
			submit() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.ruleForm.project_id = this.dataList[this.ruleForm.index].project_id;

            // 渠道添加参数
            if(window.location.search) {
              this.ruleForm.params = encodeURIComponent(window.location.search);
            }

            let data = {
              userId: '1',
              deviceId: '1',
              version: '1.12',
              token: '',
              source: 'ANDROID',
              dtMonitor: '',
              bizRequest: this.ruleForm,
            }
            submitAppointment(data).then(res => {
              this.state = 'success'
              this.$emit('changeState', '1')
            })
            // this.state = 'success'
            // this.$emit('changeState', '1')
          } else {
            this.$message.warning('请完善信息')
          }
        })
			}
		},
    mounted () {
      this.getAppointmentItem().then(res => {
        let index = 0;
        for(let i = 0; i < this.dataList.length; i++){
          if(this.activeCity.project_id === this.dataList[i].project_id) {
            this.ruleForm.index = i
            break
          }
        }
        this.changeSq()
      })
    }
  }
</script>

<style lang="stylus" >
	.appointmentForm
		font-family PingFangSC-Regular
		overflow hidden
		.w640
			width 640px
		.w240
			width 240px
		.ruleForm
			overflow: hidden
			margin-bottom: 60px
			.fonts
				.el-form-item__label
					color #272727
		.success
			.img
				margin 100px auto 0
				width 80px
				height 80px
			.tis
				text-align center
				margin-bottom 58px
				.title
					margin 35px 0 17px 0
					font-family PingFangSC-Medium
					font-size 18px
					color #272727
					font-weight 550
				.text
					line-height 28px
					color #999999
					font-size 14px
</style>
